export default __webpack_public_path__ + "static/favicon-ac687d58cb320afc707be897a94f27d9.ico";